/// <reference types="vite-plugin-pwa/react" />

import { FlexBox } from '@airship-platform/jam-web/components';
import { CloseIcon } from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1_000;
type IntervalType = ReturnType<typeof setInterval> | null;

const PwaUpdatePrompt: React.FC = () => {
  const intervalRef = useRef<IntervalType>(null);

  const onRegisteredSW = useCallback(
    (_swUrl: string, registration: ServiceWorkerRegistration | undefined) => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      if (!registration) {
        return;
      }
      intervalRef.current = setInterval(() => {
        registration.update().catch(() => void 0);
      }, UPDATE_CHECK_INTERVAL_MS);
    },
    []
  );

  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({ onRegisteredSW });
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(
    () => () => {
      const ref = intervalRef.current;
      if (ref) {
        intervalRef.current = null;
        clearInterval(ref);
      }
    },
    []
  );

  if (!needRefresh || isDismissed) {
    return null;
  }

  return (
    <Paper
      sx={{
        position: 'fixed',
        top: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        padding: '12px 20px',
        zIndex: 9999,
        background: (theme) => theme.palette.softBlue?.[200],
        borderRadius: (theme) => theme.shape.borderRadius,
        display: 'flex',
        gap: 3,
        alignItems: 'center',
      }}
    >
      <Typography>Airship update available</Typography>
      <FlexBox gap={2} alignItems="center">
        <Button onClick={() => updateServiceWorker(true)} color="info">
          Reload
        </Button>
        <IconButton aria-label="Dismiss" onClick={() => setIsDismissed(true)}>
          <CloseIcon />
        </IconButton>
      </FlexBox>
    </Paper>
  );
};

export default PwaUpdatePrompt;
